import React, { useCallback, useState } from 'react';
import { Modal, Button } from 'grab-ui';
import I18n from 'i18n-js';
import cx from 'classnames';
import { useSuppressFlagStorage } from 'components/v2/contextual-onboarding';
import {
  useLazyLoadLottie,
  ANIMATION_KEYS,
} from '../../../../hooks/useLazyLoadLottie';
import styles from './styles.less';

const onboardingID = 'bulkUploadRevamp';

export const BulkUploadOnboardingModal = () => {
  const { checkSuppress, setSuppress } = useSuppressFlagStorage(onboardingID);
  const [visible, setVisible] = useState(true);
  const { LottieComponent, isLoading: isLottieLoading } = useLazyLoadLottie(
    ANIMATION_KEYS.BUR_ONBOARDING,
    {
      width: 400,
      height: 320,
      loop: true,
      autoplay: false,
    },
  );

  const onClickButton = useCallback(
    () => {
      setVisible(false);
      setSuppress(true);
    },
    [setSuppress, setVisible],
  );

  if (checkSuppress()) {
    return null;
  }

  return (
    <Modal
      className={styles.modalContainer}
      centered
      visible={visible}
      closable={false}
      width={633}
      footer={
        <div className={styles.footerContainer} key="buttons">
          <div key="ok" className={cx(styles.btnContainer)}>
            <Button
              type="primary"
              className={cx(styles.acceptButton)}
              key="keep"
              onClick={onClickButton}
            >
              <span>
                {I18n.t('phrase.offers.MKTPLACE_OFFERS_REWARD_ACTION_GOT_IT')}
              </span>
            </Button>
          </div>
        </div>
      }
    >
      <div className={styles.onboardModal}>
        <div className={styles.onboardModalContent}>
          {!isLottieLoading && LottieComponent && <LottieComponent />}
          <div className={styles.onboardTitle}>
            {I18n.t(
              'phrase.geWebBulkUpload.express_web_route_optimisation_heading_save_fares_automultistop',
            )}
          </div>
          <div className={styles.onboardDescription}>
            {I18n.t(
              'phrase.geWebBulkUpload.express_web_route_optimisation_body_save_fares_automultistop',
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default {};
